var map = {
	"./artists/boss-doms.jpg": 736,
	"./artists/jimmy-sax.jpg": 5751,
	"./artists/mace.jpg": 6690,
	"./artists/sven-vath.jpg": 6513,
	"./experiences/benikula-hike.jpg": 730,
	"./experiences/boat-party.jpg": 8996,
	"./experiences/explore-from-the-sky.jpg": 8467,
	"./experiences/favare-night-trek.jpg": 3091,
	"./experiences/guided-meditation.jpg": 1205,
	"./experiences/guided-snorkeling.jpg": 5037,
	"./experiences/kayak-escape.jpg": 1887,
	"./experiences/mud-ritual.jpg": 7245,
	"./experiences/rooftop-yoga.jpg": 2690,
	"./experiences/satarial-thermal.jpg": 1549,
	"./experiences/special-harbor.jpg": 6981,
	"./experiences/sup.jpg": 7963,
	"./experiences/take-your-time.jpg": 4729,
	"./experiences/walk-with-donkeys.jpg": 677,
	"./hotels/kuddie-rosse.jpg": 290,
	"./hotels/mursia.jpg": 6770,
	"./hotels/pantelleria-dream.jpg": 1071,
	"./how-to-get/bkg-mobile.jpg": 8046,
	"./how-to-get/bkg.jpg": 8756,
	"./ritual/ritual.jpg": 9085,
	"./sustainability/Sustainability.jpg": 1143,
	"./tickets/bkg.jpg": 6450,
	"./tickets/card-1.jpg": 5752,
	"./tickets/card-2.jpg": 1092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;